export default __webpack_public_path__ + "static/media/cycles.04d33886.png";